<template>
  <div class="testimonial-wrap pb-100">
    <div class="container">
      <div class="row mb-40">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title text-center style1">
            <span>Testimonials</span>
            <h2>Read Our Medical Clinic Clients Reviews Discovered For You</h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="testimonial-slider-one style3"
      >
        <Slide v-for="testimonial in testimonials" :key="testimonial.id">
          <div class="testimonial-card style7">
            <div class="client-info-area">
              <div class="quote-wrap">
                <div class="quote-icon">
                  <i class="flaticon-quote-1"></i>
                </div>
                <ul class="ratings list-style">
                  <li><i class="ri-star-fill"></i></li>
                  <li><i class="ri-star-fill"></i></li>
                  <li><i class="ri-star-fill"></i></li>
                  <li><i class="ri-star-fill"></i></li>
                  <li><i class="ri-star-half-line"></i></li>
                </ul>
              </div>
              <p class="client-quote">
                {{ testimonial.shortDesc }}
              </p>
            </div>
            <div class="client-info-wrap">
              <div class="client-img">
                <img :src="testimonial.image" alt="Image" />
              </div>
              <div class="client-info">
                <h3>{{ testimonial.name }}</h3>
                <span>{{ testimonial.designation }}</span>
              </div>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "OurTestimonials",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    testimonials: [
      {
        id: 1,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        name: "Jim Morison",
        designation: "Director, BAT",
        image: require("../../assets/images/testimonials/client-1.jpg"),
      },
      {
        id: 2,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        name: "Alex Cruis",
        designation: "CEO, IBAC",
        image: require("../../assets/images/testimonials/client-2.jpg"),
      },
      {
        id: 3,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        name: "Tom Haris",
        designation: "Engineer, Olleo",
        image: require("../../assets/images/testimonials/client-3.jpg"),
      },
      {
        id: 4,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        name: "Harry Jackson",
        designation: "Enterpreneur",
        image: require("../../assets/images/testimonials/client-4.jpg"),
      },
      {
        id: 5,
        shortDesc:
          "“It is a long established fact that reader will be distract by readable content of a page wher looking at its layout. The point of using Lorm Ipsum is that it has.”",
        name: "Chris Haris",
        designation: "MD, ITe",
        image: require("../../assets/images/testimonials/client-3.jpg"),
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
    },
  }),
});
</script>